// Browser helper: PFP buffer -> cached canvas.
import { PFP_SIZE, renderPfp } from "./generator";
import type { PfpTraits } from "@degen/sim/pfp/traits";

const cache = new Map<number, HTMLCanvasElement>();

export function pfpCanvas(seed: number, traits: PfpTraits | Record<string, string>): HTMLCanvasElement {
  let c = cache.get(seed);
  if (!c) {
    c = document.createElement("canvas");
    c.width = PFP_SIZE;
    c.height = PFP_SIZE;
    c.getContext("2d")!.putImageData(new ImageData(renderPfp(seed, traits as PfpTraits) as Uint8ClampedArray<ArrayBuffer>, PFP_SIZE, PFP_SIZE), 0, 0);
    cache.set(seed, c);
  }
  return c;
}
